import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { CatalogoService } from '../../../service/CatalogoService';
import { AccionistaService } from '../../../service/AccionistaService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AccionistaGeneral } from '../../../models/ficha/AccionistaGeneral';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';
import { InputActividadEconomica } from '../../../components/ui/Formularios/InputActividadEconomica';
import { Divider } from 'primereact/divider';

export const DatosGenerales = ({ toast, catalogos, next, id, nuevoAccionista, permss, soloLectura }) => {

    const omodel = new AccionistaGeneral({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const accionistaServ = new AccionistaService();
    const catalogoSrv = new CatalogoService();
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorDP, setEcuadorDP] = useState(false);
    const [ciudadesDP, setCiudadesDP] = useState([]);
    const [ecuadorNac, setEcuadorNac] = useState(false);
    const [tieneConyugue, setTieneConyugue] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [esCedulaConyuge, setEsCedulaconyuge] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const { inDrop, inText, inCalendar, inArea } =
        InputComponent({ omodel, errors, control, permss, id, soloLectura });

    useEffect(() => {
        editarFicha();
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        if (id == null) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        accionistaServ.consultarAccionista(id ?? 0, 'seccion1').then(res => {
            const _cats = catalogos;
            if (!res.data.accionista) {
                return;
            }
            const _accionista = res.data.accionista;
            setTieneConyugue(_accionista?.estado_civil?.cat_id === _cats?.casado?.cat_id || _accionista?.estado_civil?.cat_id === _cats?.union?.cat_id);

            if (_accionista?.estado_civil?.cat_id === _cats?.casado?.cat_id || _accionista?.estado_civil?.cat_id === _cats?.union?.cat_id) {
                _accionista.fecha_nacimiento_ec = generic.stringToDate(_accionista.fecha_nacimiento_ec);
            }
            if (res.data.ciudades !== undefined) {
                setCiudades(res.data.ciudades);
            }
            if (res.data.ciudades_dp !== undefined) {
                setCiudadesDP(res.data.ciudades_dp);
            }

            setEcuador(_accionista.pais?.cat_id === _cats?.ecuador?.cat_id);
            setEcuadorDP(_accionista.pais_dp?.cat_id === _cats?.ecuador?.cat_id);
            setEcuadorNac(_accionista.nacionalidad?.cat_id === _cats?.ecuador_nac?.cat_id);

            setEsCedula(_accionista.tipo_identificacion_pn?.cat_id === _cats?.cedula?.cat_id);
            if (_accionista.tipo_identificacion_ec) {
                setEsCedulaconyuge(_accionista.tipo_identificacion_ec?.cat_id === _cats?.cedula?.cat_id);
            }

            _accionista.fecha = generic.stringToDate(_accionista.fecha);
            _accionista.fecha_nacimiento = generic.stringToDate(_accionista.fecha_nacimiento);
            _accionista.fecha_ingreso = generic.stringToDate(_accionista.fecha_ingreso);

            reset(generic.renewValues(_accionista, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        data.fecha_ingreso = generic.dateToString(data.fecha_ingreso);
        data.ec = catalogos.ecuador.cat_id;
        data.ecDP = catalogos.ecuador.cat_id;
        data.ecn = catalogos?.ecuador_nac;
        data.casado = catalogos?.casado;
        data.union = catalogos?.union;
        data.seccion = 'seccion1';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        if (tieneConyugue) {
            data.fecha_nacimiento_ec = generic.dateToString(data.fecha_nacimiento_ec);
        } else {
            delete data.fecha_nacimiento_ec;
        }
        if (ecuadorNac) {
            delete data.tiempo_reside_extranjero;
        }

        const request = !id ? accionistaServ.newAccionista(data) : accionistaServ.editarAccionista({ ...data, id });
        request.then(res => {
            generic.funcSuccess(res, toast);
            if (!id) {
                nuevoAccionista({ id: res.data?.id, nemonico: res.data?.nemonico });
            }
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia', null);
        setValue('ciudad', null);
        setCiudades([]);
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad', null);
        if (!e?.value) {
            setCiudades([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    const onChangePaisDP = (e) => {
        setEcuadorDP(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_dp', null);
        setValue('ciudad_dp', null);
        setCiudadesDP([]);
    }

    const onChangeProvinciaDP = (e) => {
        setValue('ciudad_dp', null);
        if (!e?.value) {
            setCiudadesDP([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudadesDP(res.data);
        });
    }

    const onChangeNacionalidad = (e) => {
        setEcuadorNac(e.value?.cat_id === catalogos.ecuador_nac?.cat_id);
    }

    const onChangeEstadoCivil = (e) => {
        setTieneConyugue(e.value?.cat_id === catalogos.casado?.cat_id || e.value?.cat_id === catalogos.union?.cat_id);
    }

    const onChangeTipoIdent = (e) => {
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    };

    const onChangeTipoIdentEC = (e) => {
        setEsCedulaconyuge(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion_ec');
    };

    const tipoDoc = esCedula ? 'IDEN_CEDULA' : null;
    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || 'Cédula incorrecta';
    };

    const tipoDocEC = esCedulaConyuge ? 'IDEN_CEDULA' : null;
    const reglaValidacionEC = (val) => {
        if (!tipoDocEC) return true;
        return generic.validarIdentificacionEcuador(val, tipoDocEC) || 'Cédula incorrecta';
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form id="datosGeneralesAccionistaForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('A', 'DATOS DE LA SOLICITUD', 'pi pi-cog')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {omodel.model.tipo_juridico.table && inDrop('tipo_juridico', catalogos?.tipoPersonaAccionista, { lab: omodel.optionLabel }, 3)}
                    {inCalendar('fecha', {}, omodel.model.tipo_juridico.table ? 3 : 4)}
                    {inDrop('tipo_formulario', catalogos?.tipoFormulario, { lab: omodel.optionLabel }, omodel.model.tipo_juridico.table ? 3 : 4)}
                    {inCalendar('fecha_ingreso', {}, omodel.model.tipo_juridico.table ? 3 : 4)}

                    {omodel.model.compania.table && inText('compania', { icon: 'pi pi-building' }, omodel.model.grupo_empresarial.table ? 6 : 12)}
                    {omodel.model.grupo_empresarial.table && inDrop('grupo_empresarial', generic.estadosSiNo, { lab: omodel.optionLabel }, omodel.model.compania.table ? 6 : 12)}

                    <div className="col-12 my-2">
                        <Divider type="dashed" className="my-1" />
                    </div>

                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, ecuador ? 4 : 6)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 6)
                    )}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('1', 'DATOS GENERALES', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('apellidos_dp', { icon: 'pi pi-user' }, 3)}
                    {inText('nombres_dp', { icon: 'pi pi-user' }, 3)}
                    {inDrop('tipo_identificacion_pn', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipoIdent }, 3)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}

                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel, chn: onChangeNacionalidad }, !ecuadorNac ? 3 : 4)}
                    {!ecuadorNac && inText('tiempo_reside_extranjero', { icon: 'pi pi-clock' }, 3)}
                    {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, !ecuadorNac ? 3 : 4)}
                    {inCalendar('fecha_nacimiento', {}, !ecuadorNac ? 3 : 4)}

                    {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel, chn: onChangeEstadoCivil }, omodel.model.separacion_bien.table ? 6 : 12)}
                    {omodel.model.separacion_bien.table && inDrop('separacion_bien', generic.estadosSiNo, { lab: omodel.optionLabel }, 6)}

                    <div className="col-12 mb-3 mt-4">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-home text-primary"></i>
                                UBICACIÓN Y CONTACTO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {inDrop('pais_dp', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisDP, val: false }, ecuadorDP ? 4 : 6)}
                    {ecuadorDP ? (
                        <>
                            {inDrop('provincia_dp', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaDP, val: false }, 4)}
                            {inDrop('ciudad_dp', ciudadesDP, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_dp', { icon: 'pi pi-map-marker' }, 6)
                    )}
                    {inArea('direccion', 3, 300, 12)}
                    {inText('email', { pattern: omodel.pattern, icon: 'pi pi-at' }, 4)}
                    {inText('telefono_celular', { icon: 'pi pi-mobile' }, 4)}
                    {inText('telefono_domicilio', { icon: 'pi pi-phone' }, 4)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('2', 'DATOS DEL CÓNYUGE / CONVIVIENTE (Si aplica)', 'pi pi-heart')} className="panel-ficha shadow-1 mb-4">
                {tieneConyugue ? (
                    <div className="formgrid grid">
                        {inText('apellidos_ec', { icon: 'pi pi-user' }, 3)}
                        {inText('nombres_ec', { icon: 'pi pi-user' }, 3)}
                        {inDrop('tipo_identificacion_ec', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipoIdentEC }, 3)}
                        {inText('identificacion_ec', { validate: reglaValidacionEC, icon: 'pi pi-id-card' }, 3)}

                        {inDrop('nacionalidad_ec', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}
                        {inDrop('genero_cy', catalogos?.genero, { lab: omodel.optionLabel }, 4)}
                        {inCalendar('fecha_nacimiento_ec', {}, 4)}

                        <div className="col-12 mb-3 mt-4">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-briefcase text-primary"></i>
                                    INFORMACIÓN LABORAL DEL CÓNYUGE
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inText('lugar_trabajo_ec', { icon: 'pi pi-building' }, 6)}
                        {inText('cargo_ec', { icon: 'pi pi-briefcase' }, 6)}

                        <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />
                    </div>
                ) : (
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Esta sección solo aplica si el accionista es casado o mantiene unión de hecho.</span>
                        </div>
                    </div>
                )}
            </Panel>

            <BottomActionBar onNext={next} formId="datosGeneralesAccionistaForm" loading={isSaving} isReadOnly={soloLectura} />
        </form>
    )
}